import { render, staticRenderFns } from "./ClientPortalDatatable.vue?vue&type=template&id=07d7fe57&scoped=true&"
import script from "./ClientPortalDatatable.vue?vue&type=script&lang=js&"
export * from "./ClientPortalDatatable.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortalDatatable.vue?vue&type=style&index=0&id=07d7fe57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7fe57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
